<template>
  <v-container fluid>
    <div>

      <v-card>
        <v-card-title>
          <v-row>
            <v-col cols="6">
              Notifications
            </v-col>
            <v-col cols="6">
              <v-btn color="primary" dark @click.stop="addMsg">
                Send Notification
              </v-btn>
              <v-dialog v-model="sendMsgDialog" max-width="450px">
                <v-card>
                  <v-card-text>
                    <v-form v-model="valid">
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field outlined v-model="title" :rules="titleRules" required
                              label="Notification Title" required></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-textarea name="input-7-1" outlined label="Message" auto-grow v-model="body"
                              :rules="msgRules" required></v-textarea>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="save" :disabled="!valid">Send Notification</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>

        </v-card-title>
        <v-data-table :headers="headers" :items="trains" :search="search" item-key="train_date+ train_no+name"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, 40, 50]
          }" :items-per-page="40" sort-by="trains" class="elevation-1" :loading="isLoading"
          loading-text="Loading... Please wait" :mobile-breakpoint="100">
          <template v-slot:item.id="{ item }">
            {{ trains.map(function (x) {
              return x.id;
            }).indexOf(item.id)+1}}
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize()">No Messages, click to retry</v-btn>
          </template>
        </v-data-table>
      </v-card>

    </div>
    <v-snackbar :color="color" :bottom="bottom" :top="top" :left="left" :right="right" v-model="snackbar" dark>
      <v-icon color="white" class="mr-3">
        mdi-bell-plus
      </v-icon>
      <div></div>
      <v-icon size="16" @click="snackbar = false">
        mdi-close-circle
      </v-icon>
    </v-snackbar>
  </v-container>

</template>

<script>
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
import {
  mapState,
  mapGetter,
  mapActions
} from 'vuex'
export default {
  name: 'messages',

  data() {
    return {
      search: '',
      valid: false,
      titleRules: [v => !!v || 'Title is required'],
      msgRules: [v => !!v || 'Message is required'],
      dateFormatted: moment().format('DD/MM/YYYY'),
      sendMsgDialog: false,
      errors: [],
      title: null,
      body: null,
      headers: [
        {
          text: 'Srl',
          align: 'left',
          sortable: true,
          value: 'id',

        },
        {
          text: 'Date',
          align: 'left',
          sortable: true,
          value: 'msg_time_formatted',
        },
        {
          text: 'Title',
          align: 'left',
          sortable: true,
          value: 'title',
        },
        {
          text: 'Message',
          value: 'msg_text'
        },
      ],
      train: {},
      train_loading: false,
      trains: [],
      train_date: this.curTrainDate || moment().format('YYYY-MM-DD'),
      menu1: false,
      menu2: false,
      isLoading: false,
      fetchTimer: null,
      snackbar: false
    }
  },
  mounted() {
    this.fetchTimer = setInterval(() => this.initialize(), 60000);
  },

  destroyed() {
    clearInterval(this.fetchTimer);
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },

  created() {
    this.train_date = this.curTrainDate || moment().format('YYYY-MM-DD'),
      this.initialize()
  },

  methods: {
    formatDate(date) {
      if (!date) return null
      return moment(date).format('DD/MM/YYYY')
    },
    parseDate(date) {
      if (!date) return null
      return moment(date, ['DD/MM/YYYY']).format('YYYY-MM-DD')
    },
    initialize() {
      this.menu1 = false
      this.isLoading = true
      this.trains = []
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/train/tr/msg`)
        .then(response => {
          // console.log(response);
          this.trains = response.data
          this.isLoading = false
        })
        .catch(e => {
          console.log(e)
          this.isLoading = false
        })
    },
    addMsg(item) {
      this.title = null
      this.body = null
      this.sendMsgDialog = true
    },
    close() {
      this.sendMsgDialog = false
    },
    save() {
      var msg = {
        title: this.title,
        msg: this.body,
      }
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')

      axios.post(`${process.env.VUE_APP_API_URL}/train/tr/msg`, msg)
        .then(response => {
          setTimeout(() => {
            this.initialize()
          }, 500)
          console.log(response)
        })
        .catch(e => {
          console.log(e)
        })
      this.close()
    },
  }
}
</script>
